import {SectionIntro, Section, Box} from '@primer/react-brand'
import type {FeaturedContentProps} from './types'
import {renderWithNoMarks} from '../../../utils'
import {FlexSuiteRiverAccordion} from '../../../components/FlexSuiteRiverAccordion'
import {FlexSuiteRiverStack} from '../../../components/FlexSuiteRiverStack'
import {FlexSuiteRiverBreakout} from '../../../components/FlexSuiteRiverBreakout'
import {FlexSuiteRiverFootsteps} from '../../../components/FlexSuiteRiverFootsteps'
import {FlexSuiteLargeCards} from '../../../components/FlexSuiteLargeCards'
import {
  FlexSuiteTestimonialQuote,
  FlexSuiteTestimonialStat,
  FlexSuiteTestimonialBanner,
} from '../../../components/FlexSuiteTestimonial'
import styles from './FeaturedContent.module.css'

const FeaturedContent = ({
  featureHeading,
  featureLabel,
  featureDescription,
  featureLink,
  featureDetailsOne,
  featureRiverAccordion,
  featureRiverStack,
  featureDetailsTwo,
  featureRiverBreakout,
  featureDetailsThree,
  featureDetailsThreeHeading,
  featureFootstepsLabel,
  featureFootstepsLink,
  featureFootstepsCards,
  featureLargeCards,
  featureDetailsTestimonial,
  featureTestimonialQuote,
  featureTestimonialName,
  featureTestimonialTitle,
  featureTestimonialLink,
  featureTestimonialLabel,
  featureTestimonialLogo,
  featureTestimonialStats,
  featureTestimonialImage,
}: FeaturedContentProps) => {
  return (
    <Section>
      <SectionIntro align="center">
        {featureLabel && <SectionIntro.Label>{featureLabel}</SectionIntro.Label>}
        {featureHeading && <SectionIntro.Heading>{renderWithNoMarks(featureHeading)}</SectionIntro.Heading>}
        {featureDescription && (
          <SectionIntro.Description>{renderWithNoMarks(featureDescription)}</SectionIntro.Description>
        )}
        {featureLink?.fields.href && (
          <SectionIntro.Link href={featureLink.fields.href}>{featureLink.fields.text}</SectionIntro.Link>
        )}
      </SectionIntro>
      {featureDetailsOne === 'Accordion' && featureRiverAccordion ? (
        <FlexSuiteRiverAccordion items={featureRiverAccordion} />
      ) : null}
      {featureDetailsOne === 'Stack' && featureRiverStack ? <FlexSuiteRiverStack items={featureRiverStack} /> : null}
      {featureDetailsTwo === 'Breakout' && featureRiverBreakout ? (
        <FlexSuiteRiverBreakout {...featureRiverBreakout.fields} />
      ) : null}
      {/* Blocked: featureDetailsTwo - Carousel */}
      {featureDetailsThree === 'Footsteps' && featureFootstepsCards ? (
        <Box className={styles.cardGridFrame} marginBlockStart={48} paddingBlockStart={48} paddingBlockEnd={48}>
          <FlexSuiteRiverFootsteps
            heading={featureDetailsThreeHeading}
            label={featureFootstepsLabel}
            cards={featureFootstepsCards}
            cta={featureFootstepsLink && featureFootstepsLink.fields}
          />
        </Box>
      ) : null}
      {featureDetailsThree === 'Large Cards' && featureLargeCards ? (
        <Box className={styles.cardGridFrame} marginBlockStart={48} paddingBlockStart={48} paddingBlockEnd={48}>
          <FlexSuiteLargeCards heading={featureDetailsThreeHeading} cards={featureLargeCards} />
        </Box>
      ) : null}
      {featureDetailsTestimonial === 'Quote' && featureTestimonialQuote ? (
        <Box marginBlockStart={48}>
          <FlexSuiteTestimonialQuote
            quote={featureTestimonialQuote}
            name={featureTestimonialName}
            title={featureTestimonialTitle}
            link={featureTestimonialLink && featureTestimonialLink.fields}
            logo={featureTestimonialLogo}
          />
        </Box>
      ) : null}
      {featureDetailsTestimonial === 'Statistics' &&
      featureTestimonialStats &&
      featureTestimonialQuote &&
      featureTestimonialLink &&
      featureTestimonialImage ? (
        <Box marginBlockStart={48}>
          <FlexSuiteTestimonialStat
            quote={featureTestimonialQuote}
            name={featureTestimonialName}
            title={featureTestimonialTitle}
            link={featureTestimonialLink.fields}
            label={featureTestimonialLabel}
            image={featureTestimonialImage}
            stats={featureTestimonialStats}
          />
        </Box>
      ) : null}
      {featureDetailsTestimonial === 'Brand Banner' && featureTestimonialQuote ? (
        <Box marginBlockStart={48}>
          <FlexSuiteTestimonialBanner
            quote={featureTestimonialQuote}
            link={featureTestimonialLink && featureTestimonialLink.fields}
            logo={featureTestimonialLogo}
            image={featureTestimonialImage}
          />
        </Box>
      ) : null}
    </Section>
  )
}
export {FeaturedContent}
